module.exports = __webpack_public_path__ + "img/bluesky11.4e870d27.jpg";